/**
 * Leaderboard Player
 */
class LeaderboardPlayer implements Networks.LeaderboardPlayer
{
    private id: string;
    private name: string;
    private photo: string;

    /**
     * Constructor
     */
    constructor(leaderboardPlayerData: LeaderboardPlayerExportDataObject)
    {
        if (leaderboardPlayerData)
        {
            this.id = leaderboardPlayerData.id;
            this.name = leaderboardPlayerData.name;
            this.photo = leaderboardPlayerData.photo;
        }
    }

    /**
     * Returns name of the player
     */
    public getName(): string
    {
        return this.name;
    }

    /**
     * Returns photo of the player
     */
    public getPhoto(): string
    {
        return this.photo;
    }

    /**
     * Returns ID of the player
     */
    public getID(): string
    {
        return this.id;
    }

    public static export(leaderboardPlayer: Networks.LeaderboardPlayer)
    {
        return {
            id: leaderboardPlayer.getID(),
            name: leaderboardPlayer.getName(),
            photo: leaderboardPlayer.getPhoto(),
        };
    }
}

export default LeaderboardPlayer



/*------------------------ Interfaces -------------------------*/

export interface LeaderboardPlayerExportDataObject
{
    id  : string,
    name: string,
    photo: string,
}